import { Component, Input, OnInit, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { ISearchResults } from '../../Shared/models/search.Model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SearchService } from '../../services/operations/Search.service';
import { Router } from '@angular/router';
import { DataService } from '../../facilityOperations/facOps-dashboard/data.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    standalone: false
})
export class SearchBarComponent implements OnInit {
  @Input() isESignature: string;
  @Input() switchStoreOption: boolean;
  @Input() lastAccessedFacility: number;
  @Input() customSearchDetails: any;
  @Input() isGeoLocationBasedLogIn: boolean;
  @Input() userSessionStores = [];
  @Output() loaderEmitter: EventEmitter<any> = new EventEmitter<any>();

  searchString;
  searchResultsFacWise = [];
  searchResults: ISearchResults = {
    ProspectModel: [],
    RentalModel: [],
    ReservationModel: [],
    facilityName: ['']
  };
  SearchQuery: Subject<string> = new Subject();
  searchComplete: Promise<boolean> = Promise.resolve(false);
  modalRef1: BsModalRef;
  @ViewChild('templateConfirm', { static: true }) templateConfirm: TemplateRef<any>;
  searchType: number;
  isRecordsEmpty: boolean = true;
  facilitywiseRental;
  facilitywiseReservation;
  facilitywiseProspect;
  resultSetRented;
  resultSetMovedOut;
  isGridLoadOnEnter = false;
  tempRouteObj;

  constructor(private searchService: SearchService,
    private router: Router,
    private TempData: DataService,
    private modalService: BsModalService,
    private facopsDataService: FacOpsDataService) { }

  ngOnInit() {
    this.SearchQuery.pipe(debounceTime(800)).subscribe((query) => {
      if (query !== '' && query.length >= 2) {
        if (this.isGridLoadOnEnter) {
          this.loaderEmitter.emit(true);
        }
        this.getSearchResults(query);
      } else {
        this.isGridLoadOnEnter = false;
        this.loaderEmitter.emit(false);
        this.clearSearchResults();
      }
    });
  }

  addClass(Cls) {
    (document.querySelector('#search_inner') as HTMLElement).classList.add(Cls);
  }

  removeClass(Cls) {
    (document.querySelector('#search_inner') as HTMLElement).classList.remove(Cls);
    this.searchString = '';
    this.isGridLoadOnEnter = false;
    this.loaderEmitter.emit(false);
    this.clearSearchResults();
  }

  queryChanged(data) {
    this.SearchQuery.next(data);
  }

  onEnter() {
    this.isGridLoadOnEnter = true;
    this.SearchQuery.next(this.searchString);
  }

  clearSearchResults() {
    this.searchResults = {
      ProspectModel: [],
      RentalModel: [],
      ReservationModel: [],
      facilityName: ['']
    };
    this.searchResultsFacWise = [];
    this.facilitywiseReservation = [];
    this.facilitywiseProspect = [];
    this.facilitywiseRental = [];
    this.TempData.searchResult = [];
  }

  getResultBasedOnSetting(element) {
    const obj = {
      field516: element.TransactionNoList.length > 1 ? element.TransactionNoList.join(', ') : element.TransactionNoList[0],
      field517: element.FirstName.trim() + ' ' + element.LastName,
      field518: element.LastName.trim() + ' ' + element.FirstName,
      field519: element.TenantID,
      field520: element.UnitList.length > 1 ? element.UnitList.join(', ') : element.UnitList[0],
    };
    let tempSearchresult = this.customSearchDetails.SearchField1 == 521 ? this.customSearchDetails.CustomText1 :
      this.getFieldValue(this.customSearchDetails.SearchField1, obj);
    tempSearchresult = tempSearchresult + this.getSeparatorValue(this.customSearchDetails.Separator1,
      this.customSearchDetails.SpaceSeparator1);
    tempSearchresult = tempSearchresult + (this.customSearchDetails.SearchField2 == 521 ? this.customSearchDetails.CustomText2 :
      this.getFieldValue(this.customSearchDetails.SearchField2, obj));
    tempSearchresult = tempSearchresult + this.getSeparatorValue(this.customSearchDetails.Separator2,
      this.customSearchDetails.SpaceSeparator2);
    tempSearchresult = tempSearchresult + (this.customSearchDetails.SearchField3 == 521 ? this.customSearchDetails.CustomText3 :
      this.getFieldValue(this.customSearchDetails.SearchField3, obj));
    if (this.customSearchDetails.EnableSeparator3) {
      tempSearchresult = tempSearchresult + this.getSeparatorValue(this.customSearchDetails.Separator3,
        this.customSearchDetails.SpaceSeparator3);
      tempSearchresult = tempSearchresult + (this.customSearchDetails.SearchField4 == 521 ? this.customSearchDetails.CustomText4 :
        this.getFieldValue(this.customSearchDetails.SearchField4, obj));
      if (this.customSearchDetails.EnableSeparator4) {
        tempSearchresult = tempSearchresult + this.getSeparatorValue(this.customSearchDetails.Separator4,
          this.customSearchDetails.SpaceSeparator4);
        tempSearchresult = tempSearchresult + (this.customSearchDetails.SearchField5 == 521 ? this.customSearchDetails.CustomText5 :
          this.getFieldValue(this.customSearchDetails.SearchField5, obj));
      }
    }
    return tempSearchresult;
  }

  getSeparatorValue(separator, separatorspace) {
    let value;
    switch (separator) {
      case 522: value = '–';
        break;
      case 523: value = '/';
        break;
      case 524: value = 'X';
        break;
      case 525: value = ' ';
        break;
    }
    return separatorspace == true ? (' ' + value + ' ') : value;
  }

  getFieldValue(field, objfield) {
    let value;
    switch (field) {
      case 516: value = objfield.field516;
        break;
      case 517: value = objfield.field517;
        break;
      case 518: value = objfield.field518;
        break;
      case 519: value = objfield.field519;
        break;
      case 520: value = objfield.field520;
        break;
    }
    return value;
  }
  getSearchResults(query) {
    this.clearSearchResults();
    this.isRecordsEmpty = false;
    this.searchComplete = Promise.resolve(true);
    let facId = 0;
    if (this.switchStoreOption) {
      facId = this.lastAccessedFacility;
    }
    this.searchService.getSearchResults(query, facId).subscribe((response: ISearchResults) => {
      const masterResult = JSON.parse(JSON.stringify(response));
      this.searchResults = response;
      localStorage.removeItem("calltracker");
      this.searchResults.ProspectModel = this.getUniqueByTenantId(response.ProspectModel, query, 1);
      this.searchResults.ReservationModel = this.getUniqueByTenantId(response.ReservationModel, query, 2);
      this.searchResults.RentalModel = this.getUniqueByTenantId(response.RentalModel, query, 3);
      this.resultSetRented = this.searchResults.RentalModel.filter(o => o.Status == 'Rented');
      this.resultSetMovedOut = this.searchResults.RentalModel.filter(o => o.Status == 'Moved Out');

      let facilityIdListRental = [];
      if (this.searchResults.RentalModel.length > 0) {
        this.searchResults.RentalModel.forEach(item => {
          const index = facilityIdListRental.findIndex(id => id == item.FacilityId);
          if (index == -1) {
            facilityIdListRental.push(item.FacilityId);
          }
        });
      }

      let facilityIdListProspect = [];
      if (this.searchResults.ProspectModel.length > 0) {
        this.searchResults.ProspectModel.forEach(item => {
          const index = facilityIdListProspect.findIndex(id => id == item.FacilityId);
          if (index == -1) {
            facilityIdListProspect.push(item.FacilityId);
          }
        });
      }

      let facilityIdListReserve = [];
      if (this.searchResults.ReservationModel.length > 0) {
        this.searchResults.ReservationModel.forEach(item => {
          const index = facilityIdListReserve.findIndex(id => id == item.FacilityId);
          if (index == -1) {
            facilityIdListReserve.push(item.FacilityId);
          }
        });
      }

      this.facilitywiseRental = this.groupBy(this.searchResults.RentalModel, (c) => c.FacilityId);
      this.facilitywiseProspect = this.groupBy(this.searchResults.ProspectModel, (c) => c.FacilityId);
      this.facilitywiseReservation = this.groupBy(this.searchResults.ReservationModel, (c) => c.FacilityId);
      this.searchResults.facilityName = [''];
      let objFacwise = {};
      if (this.facilitywiseRental.length) {
        facilityIdListRental.map(id => {
          const ele = this.facilitywiseRental[id];
          objFacwise = {};
          objFacwise = {
            facName: ele[0].FacilityName,
            facId: ele[0].FacilityId,
            resultSetRented: ele.filter(o => o.Status == 'Rented'),
            resultSetMovedOut: ele.filter(o => o.Status == 'Moved Out'),
            resultSetResNew: [],
            resultSetResExpired: [],
            resultSetResConfirmed: [],
            resultSetResPending: [],
            resultSetResCancelled: [],
            resultSetInqOpen: [],
            resultSetInqClosed: [],
            resultSetInqConfirmed: [],
            resultSetInqPending: [],
            resultSetInqCancelled: []
          };
          this.searchResultsFacWise.push(objFacwise);
          const obj = ele[0].FacilityName;
          this.searchResults.facilityName.push(obj);
        });
      }
      if (this.facilitywiseReservation.length) {
        if (this.searchResultsFacWise.length) {
          facilityIdListReserve.map(id => {
            const ele = this.facilitywiseReservation[id];
            let searchResultObj = this.searchResultsFacWise.find(o => o.facId == ele[0].FacilityId);
            if (searchResultObj) {
              searchResultObj.resultSetResNew = ele.filter(o => o.Status == 'New Reservation');
              searchResultObj.resultSetResExpired = ele.filter(o => o.Status == 'Expired');
              searchResultObj.resultSetResConfirmed = ele.filter(o => o.Status == 'Confirmed');
              searchResultObj.resultSetResPending = ele.filter(o => o.Status == 'Pending');
              searchResultObj.resultSetResCancelled = ele.filter(o => o.Status == 'Cancelled');
            } else {
              objFacwise = {};
              objFacwise = {
                facName: ele[0].FacilityName,
                facId: ele[0].FacilityId,
                resultSetRented: [],
                resultSetMovedOut: [],
                resultSetResNew: ele.filter(o => o.Status == 'New Reservation'),
                resultSetResExpired: ele.filter(o => o.Status == 'Expired'),
                resultSetResConfirmed: ele.filter(o => o.Status == 'Confirmed'),
                resultSetResPending: ele.filter(o => o.Status == 'Pending'),
                resultSetResCancelled: ele.filter(o => o.Status == 'Cancelled'),
                resultSetInqOpen: [],
                resultSetInqClosed: [],
                resultSetInqConfirmed: [],
                resultSetInqPending: [],
                resultSetInqCancelled: []
              };
              this.searchResultsFacWise.push(objFacwise);
              const obj = ele[0].FacilityName;
              this.searchResults.facilityName.push(obj);
            }
          });
        } else {
          facilityIdListReserve.map(id => {
            const ele = this.facilitywiseReservation[id];
            objFacwise = {};
            objFacwise = {
              facName: ele[0].FacilityName,
              facId: ele[0].FacilityId,
              resultSetRented: [],
              resultSetMovedOut: [],
              resultSetResNew: ele.filter(o => o.Status == 'New Reservation'),
              resultSetResExpired: ele.filter(o => o.Status == 'Expired'),
              resultSetResConfirmed: ele.filter(o => o.Status == 'Confirmed'),
              resultSetResPending: ele.filter(o => o.Status == 'Pending'),
              resultSetResCancelled: ele.filter(o => o.Status == 'Cancelled'),
              resultSetInqOpen: [],
              resultSetInqClosed: [],
              resultSetInqConfirmed: [],
              resultSetInqPending: [],
              resultSetInqCancelled: []
            };
            this.searchResultsFacWise.push(objFacwise);
            const obj = ele[0].FacilityName;
            this.searchResults.facilityName.push(obj);
          });
        }
      }

      if (this.facilitywiseProspect.length) {
        if (this.searchResultsFacWise.length) {
          facilityIdListProspect.map(id => {
            const ele = this.facilitywiseProspect[id];
            let searchResultObj = this.searchResultsFacWise.find(o => o.facId == ele[0].FacilityId);
            if (searchResultObj) {
              searchResultObj.resultSetInqOpen = ele.filter(o => o.Status == 'Open');
              searchResultObj.resultSetInqClosed = ele.filter(o => o.Status == 'Closed');
              searchResultObj.resultSetInqConfirmed = ele.filter(o => o.Status == 'Confirmed');
              searchResultObj.resultSetInqPending = ele.filter(o => o.Status == 'Pending');
              searchResultObj.resultSetInqCancelled = ele.filter(o => o.Status == 'Cancelled');
            } else {
              objFacwise = {};
              objFacwise = {
                facName: ele[0].FacilityName,
                facId: ele[0].FacilityId,
                resultSetRented: [],
                resultSetMovedOut: [],
                resultSetResNew: [],
                resultSetResExpired: [],
                resultSetResConfirmed: [],
                resultSetResPending: [],
                resultSetResCancelled: [],
                resultSetInqOpen: ele.filter(o => o.Status == 'Open'),
                resultSetInqClosed: ele.filter(o => o.Status == 'Closed'),
                resultSetInqConfirmed: ele.filter(o => o.Status == 'Confirmed'),
                resultSetInqPending: ele.filter(o => o.Status == 'Pending'),
                resultSetInqCancelled: ele.filter(o => o.Status == 'Cancelled')
              };
              this.searchResultsFacWise.push(objFacwise);
              const obj = ele[0].FacilityName;
              this.searchResults.facilityName.push(obj);
            }
          });
        } else {
          facilityIdListProspect.map(id => {
            const ele = this.facilitywiseProspect[id];
            objFacwise = {};
            objFacwise = {
              facName: ele[0].FacilityName,
              facId: ele[0].FacilityId,
              resultSetRented: [],
              resultSetMovedOut: [],
              resultSetResNew: [],
              resultSetResExpired: [],
              resultSetResConfirmed: [],
              resultSetResPending: [],
              resultSetResCancelled: [],
              resultSetInqOpen: ele.filter(o => o.Status == 'Open'),
              resultSetInqClosed: ele.filter(o => o.Status == 'Closed'),
              resultSetInqConfirmed: ele.filter(o => o.Status == 'Confirmed'),
              resultSetInqPending: ele.filter(o => o.Status == 'Pending'),
              resultSetInqCancelled: ele.filter(o => o.Status == 'Cancelled')
            };
            this.searchResultsFacWise.push(objFacwise);
            const obj = ele[0].FacilityName;
            this.searchResults.facilityName.push(obj);
          });
        }
      }

      if (this.searchResultsFacWise.length) {
        this.searchResultsFacWise.forEach(resultset => {
          resultset.resultSetRented.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetMovedOut.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetResNew.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetResExpired.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetResConfirmed.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetResPending.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetResCancelled.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetInqOpen.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetInqClosed.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetInqConfirmed.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetInqPending.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
          resultset.resultSetInqCancelled.map(result => {
            result['searchResult'] = this.getResultBasedOnSetting(result);
          });
        })
      }
      this.searchResults.facilityName.splice(0, 1);
      this.searchResults.facilityName.map(ele => {
      });

      if (this.isGridLoadOnEnter) {
        this.isGridLoadOnEnter = false;
        this.TempData.searchResult = masterResult;
        this.routeToCustomersearchGrid(masterResult);
      }
      this.searchComplete = Promise.resolve(false);
      this.isRecordsEmpty = true;
    }, err => {
      this.clearSearchResults();
      this.searchComplete = Promise.resolve(false);
      this.loaderEmitter.emit(false);
      this.isGridLoadOnEnter = false;
    });
  }

  getUniqueByTenantId(itemList, query, type) {
    const SearchList = [];
    let itemListTemp = JSON.parse(JSON.stringify(itemList));
    var uniqueArray = [];
    switch (type) {
      case 1: uniqueArray = itemListTemp.filter(function (item, pos) {
        const index1 = itemListTemp.findIndex(match => match.InquiryID === item.InquiryID);
        return index1 == pos;
      })
        break;
      case 2: uniqueArray = itemListTemp.filter(function (item, pos) {
        const index1 = itemListTemp.findIndex(match => match.ReservationID === item.ReservationID);
        return index1 == pos;
      });
        break;
      case 3: uniqueArray = itemListTemp.filter(function (item, pos) {
        const index1 = itemListTemp.findIndex(match => match.LeaseID === item.LeaseID);
        return index1 == pos;
      });
        break;
    }

    if (uniqueArray.length) {
      uniqueArray.forEach((ele) => {
        const obj = SearchList.find(o => (o.TenantID === ele.TenantID && o.FacilityId === ele.FacilityId));
        if (obj && ele.UnitNo) {
          if (obj.UnitList && obj.UnitList.length) {
            let unitIndex = -1;
            switch (type) {
              case 1: unitIndex = obj.UnitList.findIndex(o => (o.toLowerCase() == ele.UnitNo.toLowerCase() && o.InquiryNumber == ele.InquiryNumber));
                break;
              case 2: unitIndex = obj.UnitList.findIndex(o => (o.toLowerCase() == ele.UnitNo.toLowerCase() && o.ReservationNumber == ele.ReservationNumber));
                break;
              case 3: unitIndex = obj.UnitList.findIndex(o => (o.toLowerCase() == ele.UnitNo.toLowerCase() && o.LeaseNo == ele.LeaseNo));
                break;
            }
            if (unitIndex === -1 && (ele['Status'] !== obj.Status)) {
              const objStatusMatch = SearchList.find(o => (o.TenantID === ele.TenantID && o.FacilityId === ele.FacilityId &&
                o.Status === ele.Status));
              if (objStatusMatch) {
                objStatusMatch.UnitList.push(ele.UnitNo);
                const TransactionNo = type == 1 ? ele.InquiryNumber : (type == 2 ? ele.ReservationNumber : ele.LeaseNo);
                objStatusMatch.TransactionNoList.push(TransactionNo);
              } else {
                ele['UnitList'] = [];
                ele['UnitList'].push(ele.UnitNo);
                ele['TransactionNoList'] = [];
                const TransactionNo = type == 1 ? ele.InquiryNumber : (type == 2 ? ele.ReservationNumber : ele.LeaseNo);
                ele['TransactionNoList'].push(TransactionNo);
                SearchList.push(ele);
                this.getSearchType(ele, query);
              }
            } else
              if (unitIndex === -1) {
                obj.UnitList.push(ele.UnitNo);
                const TransactionNo = type == 1 ? ele.InquiryNumber : (type == 2 ? ele.ReservationNumber : ele.LeaseNo);
                obj.TransactionNoList.push(TransactionNo);
              }
          } else {
            obj.UnitList.push(ele.UnitNo);
            const TransactionNo = type == 1 ? ele.InquiryNumber : (type == 2 ? ele.ReservationNumber : ele.LeaseNo);
            obj.TransactionNoList.push(TransactionNo);
          }

        } else {
          ele['UnitList'] = [];
          ele['UnitList'].push(ele.UnitNo);
          ele['TransactionNoList'] = [];
          const TransactionNo = type == 1 ? ele.InquiryNumber : (type == 2 ? ele.ReservationNumber : ele.LeaseNo);
          ele['TransactionNoList'].push(TransactionNo);
          SearchList.push(ele);
          this.getSearchType(ele, query);
        }
      });
    }
    return SearchList;
  }

  getSearchType(obj, query) {
    if (this.validateEmail(query)) {
      obj.searchType = 2;
    } else if (this.isSearchedByUnitNo(obj, query)) {
      obj.searchType = 3;
    } else if (this.isSearchByPhone(obj, query)) {
      obj.searchType = 4;
    } else {
      obj.searchType = 1;
    }
  }

  routeToCustomersearchGrid(res) {
    this.TempData.searchGridViewEmitter.emit(res);
    const url = `customer/CustomerSearchResults`;
    this.router.navigate([url]);
  }

  routeToCustomer(tenantObj, type) {
    if ((this.lastAccessedFacility != tenantObj.FacilityId) && this.lastAccessedFacility != 0 && this.lastAccessedFacility != null) {
      const indexStore = this.userSessionStores.findIndex(record => record.Id == tenantObj.FacilityId);
      if (!this.isGeoLocationBasedLogIn && indexStore != -1) {
        this.modalRef1 = this.modalService.show(this.templateConfirm, {
          class: 'modal-dialog  alert_box modal-dialog-centered',
          backdrop: 'static',
          keyboard: false
        });
        this.tempRouteObj = {
          tenantObj: tenantObj,
          type: type
        }
      }
    } else {
      this.aftervalidateRouteToCustomer(tenantObj, type);
    }
  }

  proceedRouteDifferentStore() {
    this.modalRef1.hide();
    this.aftervalidateRouteToCustomer(this.tempRouteObj.tenantObj, this.tempRouteObj.type);
  }

  aftervalidateRouteToCustomer(tenantObj, type) {
    let url;
    const obj = {
      tenantId: tenantObj.TenantID,
      facilityID: tenantObj.FacilityId,
      leaseNo: tenantObj.LeaseNo,
      tab: 'dashboard'
    };
    this.TempData.custimerInfoStorage = obj;
    if (type === 1) {
      let tabsInvoked = {
        Rental: false,
        CustomerInfo: false,
        Dashboard: false,
        Cases: false
      }
      this.TempData.azureSearchEmitter.emit(obj);
      this.TempData.fromAzureSearch = tabsInvoked;
      url = `customer/customer/dashboard/${tenantObj.FacilityId}/${tenantObj.LeaseNo}/${tenantObj.TenantID}`;
    } else if (type === 2) {
      url = `prospect/prsEd/${tenantObj.TenantID}/true/ed`;
    } else {
      url = `prospect/prsEd/${tenantObj.TenantID}/true/ed`;
    }
    this.facopsDataService.isGlobalSearch = true;
    this.router.navigate([url]);
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), []);
  }

  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  isSearchedByUnitNo(ele, query) {
    let isPresent = false;
    isPresent = ele.UnitNo.toLowerCase().includes(query.toLowerCase());
    if (isPresent) {
      return true;
    }
    return false;
  }

  isSearchByPhone(ele, query) {
    if (query.length > 3) {
      const isPresent = ele.CellPhone.includes(query) || ele.WorkPhone.includes(query);
      if (isPresent) {
        return true;
      }
    }
    return false;
  }
}
